import { connect } from "react-redux"
import { clearSubmitErrors } from "redux-form"
import {
    createDropSsoResponseAction,
    login,
    ssoStart,
    selectEmailChecked,
    selectRedirectUrl,
    selectSsoData,
    logout,
    submitTwoFactorAuthentication,
} from "../../redux/reducers/authentication/index"

const mapDispatchToProps = {
    doSsoCheck: ssoStart,
    doLogin: login,
    onEmailChanged: () => (dispatch) => {
        dispatch(createDropSsoResponseAction())
        dispatch(clearSubmitErrors("login"))
    },
    logout,
    submitTwoFactorAuthentication,
}

const mapStateToProps = state => ({
    emailChecked: selectEmailChecked(state),
    ssoData: selectSsoData(state),
    redirectUrl: selectRedirectUrl(state),
})

export default connect(mapStateToProps, mapDispatchToProps)
